export const creatorOptions = {
  showLogicTab: true,
  isAutoSave: true,
  showTitle: true,
  showJSONEditorTab: true,
};

export const defaultJson = {
  title: "",
  pages: [
    {
      name: 'Name',
      elements: [
        {
          name: 'FirstName',
          title: 'Enter your first name:',
          type: 'text',
        },
        {
          name: 'LastName',
          title: 'Enter your last name:',
          type: 'text',
        },
      ],
    },
  ],
};

export const apiEndpoints = {
  encryptId: `${process.env.REACT_APP_API_BASE_URL}/encryptId`,
  updateLink: `${process.env.REACT_APP_API_BASE_URL}/updateLink`,
  formSave: `${process.env.REACT_APP_API_BASE_URL}/formSave`,
  formUpdate: `${process.env.REACT_APP_API_BASE_URL}/formUpdate`, // Added formUpdate endpoint
  formGet: `${process.env.REACT_APP_API_BASE_URL}/ArrayForm`, // Added for form retrieval
  getTemplates: `${process.env.REACT_APP_API_BASE_URL}/getTemplates`
};

export const messages = {
  successFormSave: "Your form has been saved successfully!",
  errorFormSave: "Failed to save the form data. Please try again later.",
  errorEncryptId: "Failed to encrypt ID.",
  errorSaveLink: "Failed to save the form link. Please try again later.",
  errorGeneral: "An error occurred while saving the form data.",
  errordateRange: "Please provide both start and end dates.",
  errorDuration: "Please provide a valid duration (1-30 days).", // New: Error for missing/invalid duration
  errorFrequency: "Please select a recurrence frequency." // New: Error for missing frequency
};

export const formTypes = [
  { value: 'open', label: 'Open' },
  { value: 'one-time', label: 'One-time' },
  { value: 'recurring', label: 'Recurring' }
];

export const recurrenceFrequencies = [ // New: Enum for recurrence frequency options
  { value: 'weekly', label: 'Weekly' },
  { value: 'biweekly', label: 'Biweekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'half-yearly', label: 'Half-Yearly' },
  { value: 'yearly', label: 'Yearly' },
];

export const frequencyDays = {
  weekly: 7,
  biweekly: 14,
  monthly: 30,
  quarterly: 90,
  'half-yearly': 180,
  yearly: 365
};